// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3L2TU","actionsCol":"EnrolledClinics_actionsCol__2kx2A"};